/** Known misspellings → canonical paths (lowercase, no trailing slash). */
export const ROUTE_ALIASES = {
  "/professionalss": "/professionals",
  "/profesionals": "/professionals",
  "/professionlals": "/professionals",
  "/enquire": "/enquiry",
  "/enquiry-success": "/requirement-success",
  "/create-bussiness": "/create-business",
  "/createbusiness": "/create-business",
  "/contact-us": "/contact",
  "/download": "/downloads",
  "/privacypolicy": "/privacy-policy",
  "/privacy": "/privacy-policy",
  "/term": "/terms",
  "/cookie": "/cookie-policy",
};

function normalizePathname(pathname) {
  const trimmed = (pathname || "/").replace(/\/+$/, "");
  return trimmed === "" ? "/" : trimmed;
}

export function getCanonicalPath(pathname) {
  const normalized = normalizePathname(pathname);
  return ROUTE_ALIASES[normalized.toLowerCase()] || null;
}
